// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-menu::part(container) {
  border-radius: var(--ion-padding) 0 0 var(--ion-padding);
  padding-top: var(--ion-safe-area-top, 0);
}

ion-toolbar {
  --background: none;
}
ion-toolbar.menu-toolbar {
  position: fixed;
}
ion-toolbar.menu-toolbar .close {
  margin-right: var(--spacing-quarter);
}

.spacer {
  height: var(--spacing-half);
}

ion-list {
  margin-bottom: var(--spacing-half);
}

ion-item.selected ion-label {
  color: var(--ion-color-primary);
}

ion-list-header {
  margin-bottom: var(--spacing-half);
  color: var(--ion-color-primary);
  text-transform: uppercase;
  font-size: var(--font-size-section);
  font-weight: var(--font-weight-semibold);
}

ion-icon {
  color: var(--ion-color-medium);
}

.text {
  padding-inline-start: calc(var(--ion-safe-area-left, 0px) + 20px);
}
.text h2 {
  margin-bottom: var(--spacing-half);
  color: var(--ion-color-primary);
  text-transform: uppercase;
  font-size: var(--font-size-section);
  font-weight: var(--font-weight-semibold);
}
.text ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.text ul li {
  margin-bottom: var(--spacing-half);
}
.text ul li small {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACC,wDAAA;EACA,wCAAA;AACD;;AAGA;EACC,kBAAA;AAAD;AAEC;EACC,eAAA;AAAF;AAEE;EACC,oCAAA;AAAH;;AAMA;EACC,2BAAA;AAHD;;AAOA;EACC,kCAAA;AAJD;;AAWE;EACC,+BAAA;AARH;;AAcA;EACC,kCAAA;EAEA,+BAAA;EACA,yBAAA;EACA,mCAAA;EACA,wCAAA;AAZD;;AAgBA;EACC,8BAAA;AAbD;;AAgBA;EACC,iEAAA;AAbD;AAeC;EACC,kCAAA;EACA,+BAAA;EACA,yBAAA;EACA,mCAAA;EACA,wCAAA;AAbF;AAgBC;EACC,gBAAA;EACA,SAAA;EACA,UAAA;AAdF;AAgBE;EACC,kCAAA;AAdH;AAgBG;EACC,cAAA;AAdJ","sourcesContent":["ion-menu::part(container) {\n\tborder-radius: var(--ion-padding) 0 0 var(--ion-padding);\n\tpadding-top: var(--ion-safe-area-top, 0);\n}\n\n\nion-toolbar {\n\t--background: none;\n\n\t&.menu-toolbar {\n\t\tposition: fixed;\n\n\t\t.close {\n\t\t\tmargin-right: var(--spacing-quarter);\n\t\t}\n\t}\n}\n\n\n.spacer {\n\theight: var(--spacing-half);\n}\n\n\nion-list {\n\tmargin-bottom: var(--spacing-half);\n}\n\n\nion-item {\n\t&.selected {\n\n\t\tion-label {\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\t}\n}\n\n\nion-list-header {\n\tmargin-bottom: var(--spacing-half);\n\n\tcolor: var(--ion-color-primary);\n\ttext-transform: uppercase;\n\tfont-size: var(--font-size-section);\n\tfont-weight: var(--font-weight-semibold);\n}\n\n\nion-icon {\n\tcolor: var(--ion-color-medium);\n}\n\n.text {\n\tpadding-inline-start: calc(var(--ion-safe-area-left, 0px) + 20px);\n\n\th2 {\n\t\tmargin-bottom: var(--spacing-half);\n\t\tcolor: var(--ion-color-primary);\n\t\ttext-transform: uppercase;\n\t\tfont-size: var(--font-size-section);\n\t\tfont-weight: var(--font-weight-semibold);\n\t}\n\n\tul {\n\t\tlist-style: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\n\t\tli {\n\t\t\tmargin-bottom: var(--spacing-half);\n\n\t\t\tsmall {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
